import { Box } from '@mui/material';
import { styled } from '@mui/system';

export const AppBox = styled(Box)({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	minHeight: '100%',
});

export const AppBar = styled(Box)(() => ({
	display: 'flex',
	flexDirection: 'column',
	background: 'transparent',
	overflow: 'hidden',
	padding: '8px',
	gap: '8px',
}));
